import { render } from "./gateway-attribute-list-user.vue?vue&type=template&id=3b3adc4f&scoped=true"
import script from "./gateway-attribute-list-user.vue?vue&type=script&lang=js"
export * from "./gateway-attribute-list-user.vue?vue&type=script&lang=js"

import "./gateway-attribute-list-user.vue?vue&type=style&index=0&id=3b3adc4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3adc4f"]])

export default __exports__